import { FlexBox } from 'src/ui/common/atoms/flex-box';
import { Typography } from 'src/ui/common/atoms/typography';
import { speed } from 'src/ui/common/config/animations';
import { media } from 'src/ui/common/mixins/media';
import styled from 'styled-components';

export const StyledCheckedItem = styled(FlexBox)<{ checked: boolean }>`
    cursor: pointer;
    height: 45px;
    border: 1px solid #e6e6e6;
    padding: 0 15px;
    color: white;
    transition: background-color ${speed.content} ease-in-out, border-color ${speed.content} ease-in-out;

    & + & {
        margin-top: 10px;
    }
`;

export const StyledCurrency = styled(Typography)`
    position: absolute;
    right: 20px;
    top: 50%;
    margin-top: -8px;
`;

export const PriceRangeWrapper = styled(FlexBox)`
    margin-bottom: 10px;

    & > div {
        flex: 1;

        input {
            width: 100%;
            padding-right: 35px;
            text-overflow: ellipsis;
        }

        & > span {
            font-size: 12px;
        }
    }

    & > span {
        color: white;
        margin: 0 10px;
        white-space: nowrap;
        line-height: 40px;
    }

    ${media.md`
      & > span {
        line-height: 50px;
      }    
  `}
`;
